import GeniusModal from './GeniusModal';

export default GeniusModal;